import { useBreakpointValue } from '@chakra-ui/react';
import {
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip
} from 'recharts';

type IDecisionRatioResponse = {
  accept: number;
  reject: number;
  revise: number;
};

interface Props {
  data: IDecisionRatioResponse;
}

export const DecisionRatioChart = ({ data }: Props) => {
  const isMobile = useBreakpointValue({ base: true, md: false }) ?? false;
  const COLORS = ['#22C55E', '#EF4444', '#F59E0B'];

  const formatted = [
    { name: 'Accept', value: data.accept },
    { name: 'Reject', value: data.reject },
    { name: 'Revise', value: data.revise }
  ];

  const total = formatted.reduce((sum, item) => sum + item.value, 0);

  return (
    <ResponsiveContainer width="100%" height={isMobile ? 260 : 300}>
      <PieChart
        margin={{
          top: 8,
          right: isMobile ? 8 : 16,
          left: isMobile ? 8 : 16,
          bottom: 8
        }}
      >
        <Pie
          data={formatted}
          dataKey="value"
          nameKey="name"
          innerRadius={isMobile ? 42 : 58}
          outerRadius={isMobile ? 78 : 102}
          paddingAngle={3}
          stroke="#FFFFFF"
          strokeWidth={2}
          isAnimationActive
          animationDuration={1000}
          animationEasing="ease-out"
          label={
            isMobile
              ? false
              : ({ value }) =>
                  `${Math.round(((value || 0) / (total || 1)) * 100)}%`
          }
        >
          {formatted.map((entry, index) => (
            <Cell key={entry.name} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip
          contentStyle={{
            borderRadius: 12,
            border: '1px solid #CBD5E1',
            boxShadow: '0 12px 28px rgba(15, 23, 42, 0.14)',
            backgroundColor: '#FFFFFF'
          }}
          formatter={(value, name) => [`${value}`, `${name}`]}
        />
        <Legend
          verticalAlign="bottom"
          wrapperStyle={{
            fontSize: isMobile ? 11 : 12,
            lineHeight: isMobile ? '16px' : '20px'
          }}
        />
      </PieChart>
    </ResponsiveContainer>
  );
};
